module.exports = __webpack_public_path__ + "static/media/socials-facebook-color.320d742e.svg";